// extracted by mini-css-extract-plugin
module.exports = {"vInk":"#131313","subtitle":"Subtitle__subtitle___c-sz-","centerText":"Subtitle__centerText___rRJ8G"};